import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, catchError, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private baseUrl = environment.apiUrl;
  cacInfo: { [key: string]: any } = {};
  public loader = false;

  emailRes: any = '';

  constructor(
    private http: HttpClient,
    private r: Router,
    private tstr: ToastrService
  ) { }
  loggedIn() {
    return !!localStorage.getItem('user');
  }
  private httpClientHeaders() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')!}`,
      }),
    };
  }

  errHdlr = (err: any, caught: Observable<any>): any => {
    this.loader = false;

    if (err.status == 401) {
      this.tstr.error('incorrect password');
    } else if (err.status == 400 && err.error.error.detail) {
      console.log(err.error.error.detail)
      this.tstr.error('invalid CAC Number, please try again');
    } else {
      this.tstr.error('' + JSON.stringify(err.error));

      if (err.error.email) {
        this.tstr.error('' + err.error.email[0]);
      }
      this.tstr.error('' + err.error.message);
      this.tstr.error('' + err.error);
    }
  };

  basicCac(data: {}) {
    this.loader = true;
    return this.http
      .post<{ [key: string]: any }>(
        environment.cacUrl + 'verifyme/basiccac',
        data,
        {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
          "X-API-Key": environment.METAMAP_KEY
          }),
        }
      )
      .pipe(
        catchError(this.errHdlr),
        map((r) => r['data'])
      );
  }

  register(data: {}) {
    this.loader = true;
    let y = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    return this.http
      .post(this.baseUrl + 'api/create/company', data, y)
      .pipe(catchError(this.errHdlr));
  }
  signIn(data: {}) {
    this.loader = true;
    return this.http
      .post(this.baseUrl + 'api/login', data, this.httpClientHeaders())
      .pipe(catchError(this.errHdlr));
  }
  chkcr() {
    if (!localStorage.getItem('user')) {
      this.r.navigateByUrl('signin');
    }
  }
  updt(data: FormData) {
    this.loader = true;
    let y = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${localStorage.getItem('token')!}`,
      }),
    };
    return this.http
      .post(this.baseUrl + 'api/upload/cac', data, y)
      .pipe(catchError(this.errHdlr));
  }

  emailService(email: {}) {
    this.loader = false;
    const emailUrl = `${this.baseUrl}api/password/reset/token`;
    return this.http
      .post(emailUrl, email, this.httpClientHeaders())

      .pipe(catchError(this.errHdlr));
  }

  passwordReset(password: {}) {
    let y = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    const emailUrl = `${this.baseUrl}api/password/reset`;
    return this.http.post(emailUrl, password, y).pipe(catchError(this.errHdlr));
  }
}
